// extracted by mini-css-extract-plugin
export default {"spacing":"30px","loginForm":"LoginForm_loginForm__KjLm-","infoMsg":"LoginForm_infoMsg__duXec","verificationForm":"LoginForm_verificationForm__PnpTB"};